export const getWhereConditionForIsVisible = (isVisible = true) => {
	return `masterData(current(masterVariant(attributes(name=\\"isVisible\\" and value=${
		isVisible ? "true" : "false"
	}))))`
}
